import { api } from './configs/axiosConfig';
import Cookies from 'js-cookie';
export const AuthorizationAPI = {
    getToken: async function () {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/authentication/token`);
        return response?.data;
    },
    getUser: async function (userName) {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/user?username=${userName}`);
        return response.data;
    },
    getUserProfilePicture: async function () {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/user/profile-picture`, {
            validateStatus: () => true
        });
        return response.status === 200 ? response.data : null;
    },
    getPolicy: async function () {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/policy`);
        return response.data;
    },
    refreshToken: async function () {
        if (Cookies.get('refresh_token')) {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/authentication/token/refresh`, {
                headers: {
                    refreshtoken: Cookies.get('refresh_token')
                }
            });
            return response?.data;
        }
    },
    logout: async function () {
        if (Cookies.get('access_token')) {
            const response = await api.post(`${process.env.REACT_APP_API_URL}/authentication/logout`);
            return response?.data;
        }
    },
    logError: async function (data) {
        const response = await api.post(`${process.env.REACT_APP_API_URL}/error/logError`, data, { skipErrorToast: true });
        return response.data;
    }
};
